import React, { useContext, useEffect, useRef, useState } from 'react'
import TopNavbar from '../../CommonComponent/topNavbar/TopNavbar'
import Sidebar from '../../CommonComponent/sidebar/Sidebar'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuctionBYIdGet, AuctionGetTeam, BidReg, BidAuctionTeamWinner, UserGetId, getBIdCount, RefreshToken, BidStatus, AuctionAll, AuctionTeamById, AuctionPlaceBid } from '../../redux/auth-reducer/auth-service'
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs'
import Modal from 'react-bootstrap/Modal';
import soundFile from './sound.mp3';
import soundFileBid from './sound-bid.mp3';
import * as signalR from "@microsoft/signalr";
import { ImageUrl, SignalRUrl } from '../../utils/config/config'
import { Context } from '../../redux/Context'
import moment from 'moment'
import { Loader } from 'rsuite'
import { CheckLg, ClockFill } from 'react-bootstrap-icons'
import introJs from 'intro.js';
import 'intro.js/introjs.css';

export const PlaceBid = () => {

    const [data, setData] = useState(false);
    const [validated, setValidated] = useState(false);
    const [auctionList, setAuctionList] = useState([]);
    const [bidCountList, setBidCountList] = useState();
    const [userData, setUserData] = useState();
    const [oldBidAmount, setOldBidAmount] = useState();
    const [errorMessage, setErrorMessage] = useState(false)
    const [auctionIdData, setAuctionIdData] = useState();
    const [teamList, setTeamList] = useState();
    const [disabled, setDisabled] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const [minutes, setMinutes] = useState(0);
    const [CurrentBidAmount, setCurrentBidAmount] = useState();
    const [seconds, setSeconds] = useState();
    const [show, setShow] = useState(false);

    const intervalRef = useRef(null);
    const [signalRData, setSignalRData] = useState([]);
    // const [hubConnection, setHubConnection] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [bidStatusAuction, setBidStatusAuction] = useState();
    const [currentTotalPlaceBId, setCurrentTotalPlaceBId] = useState(0);
    const [dataListItemSingnalR, setDataListItemSingnalR] = useState();
    const [placeBid, setPlaceBid] = useState(null);
    const [loading, setLoading] = useState(false);
    const [placeBidTeamId, setPlaceBidTeamId] = useState(null);
    const [item, setItem] = useState(window.location.pathname);
    const [totalpoolamount, setTotalpoolAmount] = useState("")
    const [auctionbyid, setAuctionById] = useState({
        winnerCount: 1,
        winnerTitle: "",
        winnerPercentage: 0

    })
    const [winnerpercentages, setwinnerpercentages] = useState([])
    const [winnertitles, setwinnertitles] = useState([])
    const [auctionPlaceData, setAuctionPlaceData] = useState();
    const [autionTeamImage, setAuctionTeamImage] = useState()
    const { state } = useLocation();

    const [stateData, setStateData] = useState();
    const { hubConnection } = useContext(Context);
    const navigate = useNavigate()

    const isUser = JSON.parse(localStorage.getItem('isUser'));
    const userId = isUser.userId;
    //    useEffect(()=>{
    //     setStateData(state)
    //    },[state])
    useEffect(() => {
        console.log(state, "Location State");
    }, [state]);


    const autionAllData = autionTeamImage && autionTeamImage?.data

    useEffect(() => {
        let audio;
        if (minutes === 0 && seconds === 0) {
            audio = new Audio(soundFile);
            audio.play().catch(error => {
                console.error("Error playing sound:", error);
            });

            // Stop the sound after 3 seconds
            const timeoutId = setTimeout(() => {
                audio.pause();
                audio.currentTime = 0;
            }, 3000); // 3000 milliseconds = 3 seconds


            return () => {
                clearTimeout(timeoutId);
                if (audio) {
                    audio.pause();
                    audio.currentTime = 0;
                }
            };
        }
    }, [minutes, seconds]);


    useEffect(() => {
        (async function () {

            // const userId = isUser.userId;

            const auctiondat = await AuctionBYIdGet(state?.auctionId)
            const result = await AuctionPlaceBid(state?.auctionId)
            setAuctionPlaceData(result?.data)
            setAuctionById({
                winnerCount: parseInt(auctiondat?.winnerCount),
                winnerTitle: auctiondat?.winnerTitle,
                winnerPercentage: (auctiondat?.winnerPercentage)
            })
            setwinnerpercentages(auctiondat?.winnerPercentage?.split(","))
            setwinnertitles(auctiondat?.winnerTitle?.split(","))

        })()
    }, [])


    useEffect(() => {
        let audioBId;
        if (minutes === 0 && seconds === 3) {
            audioBId = new Audio(soundFileBid);
            audioBId.play().catch(error => {
                console.error("Error playing sound:", error);
            });

            // Stop the sound after 3 seconds
            const timeoutId = setTimeout(() => {
                audioBId.pause();
                audioBId.currentTime = 0;
            }, 3000); // 3000 milliseconds = 3 seconds


            return () => {
                clearTimeout(timeoutId);
                if (audioBId) {
                    audioBId.pause();
                    audioBId.currentTime = 0;
                }
            };
        }
    }, [minutes, seconds]);



    const handleClose = () => {
        navigate("/player/AuctionPlayer");
        localStorage.setItem("itemnav", "/Player/AuctionPlayer")

    }

    const sidebarfun = () => {
        setData(!data)
    }

    useEffect(() => {
        if (currentTotalPlaceBId) {
            navigate(`/Player/PlaceBid?auctionId`, { state: { ...state, ...currentTotalPlaceBId } });
        }
    }, [currentTotalPlaceBId])


    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const registerData = [{
            // "crudOperationId": true,
            // "bidId": 0,
            "teamId": Number(state?.teamId),
            "auctionId": currentTotalPlaceBId?.auctionId,
            "startingBid": currentTotalPlaceBId?.startingBid,
            "bidTime": state?.bidTime,
            "totalPlacedBids": currentTotalPlaceBId?.totalPlacedBids,
            "bidIncrement": currentTotalPlaceBId?.bidIncrement,
            // "currentBidAmount": Number(currentTotalPlaceBId?.bidIncrement + currentTotalPlaceBId?.startingBid),
            "currentBidAmount": Number(currentTotalPlaceBId?.currentBidAmount),
            "bidAmount": Number(oldBidAmount) || currentTotalPlaceBId?.currentBidAmount,
            "bidPlacedBy": Number(userId),
        }]


        await BidReg(registerData).then((res) => {


            if (res?.data?.status == true) {
                setLoading(false);
                toast.success(res?.data?.message);
                // setDisabled(true);
                // navigate('/Player/Bid');
                setOldBidAmount('')
                setCurrentTotalPlaceBId((prev) => {
                    return { ...prev, remainingBidTime: moment().add(state.bidTime, 'minutes').format() }
                })

                AuctionTeamFn();

            }
            else {
                setLoading(false);
                toast.error(res?.data?.message);
            }
        })
    };


    useEffect(() => {
        const AuctionID = async () => {
            setCurrentTotalPlaceBId({ ...state, remainingBidTime: state.recievedAt, totalPoolAmount: state?.totalPoolAmount, totalPlacedBids: state?.totalPlacedBids, currentBidAmount: state?.currentBidAmount, teamName: state?.teamName, startingBid: state?.startingBid })
        }
        AuctionID();

    }, [])

    const handelBidAmount = (e) => {
        setErrorMessage(false);
        const value = e.target.value;
        if (value >= 0) {
            setInputValue(value);
        }
        setOldBidAmount(e.target.value);
    }


    useEffect(() => {
        if (minutes === 0 && seconds === 0) {
            setTimeout(() => {
                navigate("/player/AuctionPlayer");

            }, 2000)
            setShow(true);
        }
    }, [minutes, seconds])

    console.log(winnertitles, winnerpercentages, totalpoolamount, "hfrjgbrf")

    useEffect(() => {
        if (hubConnection) {
            hubConnection.on("ReceiveBidStatus", (data) => {
                data.map((item) => {

                    // if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                    //     let remainingtimer = moment().add(item?.remainingBidTime.split(":")[0], 'minutes').add(item?.remainingBidTime.split(":")[1], 'seconds').format()
                    //     setCurrentTotalPlaceBId({ ...item, remainingBidTime: remainingtimer })
                    // }


                    if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                        const timeParts = item.remainingBidTime.split(":");
                        const minutes = parseInt(timeParts[0], 10); // Get minutes as an integer
                        const seconds = parseInt(timeParts[1], 10); // Get seconds as an integer

                        let remainingTimer = moment().add(minutes, 'minutes').add(seconds, 'seconds').format();
                        setCurrentTotalPlaceBId({ ...item, remainingBidTime: remainingTimer });

                        // Set minutes and seconds separately
                        setMinutes(minutes);
                        setSeconds(seconds);
                    }


                })
                setSignalRData(data);
            });



            return () => {
                hubConnection.off("ReceiveBidStatus");
            };
        }
    }, [hubConnection]);


    useEffect(() => {
        if (hubConnection) {

            hubConnection.on("ReceiveCurrentBid", (data) => {
                setDataListItemSingnalR(data);
                
                data.map((item) => {

                    // if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                    //     let remainingtimer = moment().add(item?.remainingBidTime.split(":")[0], 'minutes').add(item?.remainingBidTime.split(":")[1], 'seconds').format()
                    //     setCurrentTotalPlaceBId({ ...item, remainingBidTime: remainingtimer })
                    // }


                    if (item.auctionId === state.auctionId && item.teamId === state.teamId) {
                        const timeParts = item.remainingBidTime.split(":");
                        const minutes = parseInt(timeParts[0], 10); // Get minutes as an integer
                        const seconds = parseInt(timeParts[1], 10); // Get seconds as an integer

                        let remainingTimer = moment().add(minutes, 'minutes').add(seconds, 'seconds').format();
                        setCurrentTotalPlaceBId({ ...item, remainingBidTime: remainingTimer });

                        // Set minutes and seconds separately
                        setMinutes(minutes);
                        setSeconds(seconds);
                    }


                })
            });
            return () => {
                hubConnection.off("ReceiveCurrentBid");
            };
        }
    }, [hubConnection]);

    var getId = localStorage.getItem("placebid");
    var getTeamId = localStorage.getItem("placeTeamId");
    var getAuctionId = localStorage.getItem("AuctionId");



    useEffect(() => {
        let idPlaceAuctionId = dataListItemSingnalR?.map((item) => (
            item?.auctionId
        ))
        // Read from localStorage when component mounts
        let storedPlaceBid = localStorage.getItem("idPlaceAuctionId");
        if (storedPlaceBid) {
            setPlaceBid(storedPlaceBid);

        }

        // Check if dataListItemSingnalR is empty
        if (dataListItemSingnalR?.length === 0) {

        } else {
            // If the array is not empty, check if idPlaceBId is valid
            if (idPlaceAuctionId) {
                localStorage.setItem("AuctionId", idPlaceAuctionId);
                setPlaceBid(idPlaceAuctionId); // Update state with the new value

            } else {

            }
        }
    }, [dataListItemSingnalR]);

    useEffect(() => {

        let idPlaceBId = dataListItemSingnalR?.map((item) => (
            item?.bidPlacedBy
        ))

        // Read from localStorage when component mounts
        let storedPlaceBid = localStorage.getItem("placebid");
        if (storedPlaceBid) {
            setPlaceBid(storedPlaceBid);

        }

        // Check if dataListItemSingnalR is empty
        if (dataListItemSingnalR?.length === 0) {

        } else {
            // If the array is not empty, check if idPlaceBId is valid
            if (idPlaceBId) {

                setPlaceBid(idPlaceBId); // Update state with the new value

            } else {

            }
        }
    }, [dataListItemSingnalR]);

    useEffect(() => {
        let idPlaceTeamId = dataListItemSingnalR?.map((item) => (
            item?.teamId
        ))
        // Read from localStorage when component mounts
        let storedPlaceBid = localStorage.getItem("placeTeamId");
        if (storedPlaceBid) {
            setPlaceBidTeamId(idPlaceTeamId);

        }

        // Check if dataListItemSingnalR is empty
        if (dataListItemSingnalR?.length === 0) {

        } else {
            // If the array is not empty, check if idPlaceBId is valid
            if (idPlaceTeamId) {
                localStorage.setItem("placeTeamId", idPlaceTeamId);
                setPlaceBidTeamId(idPlaceTeamId); // Update state with the new value

            } else {

            }
        }
    }, [dataListItemSingnalR]);

    useEffect(() => {
        // Check if the status is "Paused"
        if (currentTotalPlaceBId?.status === "Paused") {
            setTimeout(() => {
                navigate('/Player/AuctionPlayer');
            }, 5000);
            // Replace with your target route
        }
    }, [currentTotalPlaceBId?.status]);




    // Our code ///////////////////////


    function convertBidTimeToFormattedString(bidTimeInMinutes) {
        // Convert minutes to total seconds
        const totalSeconds = bidTimeInMinutes * 60; // 60 seconds in a minute

        // Calculate minutes and seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds % 60);

        // Format as "MM:SS"
        const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        return formattedTime;
    }


    const updateTime = (time) => {
        const [minutesStr, secondsStr] = time?.split(':') ?? [0, 0];
        const updatedMinutes = parseInt(minutesStr, 10);
        const updatedSeconds = parseInt(secondsStr, 10);
        if (!isNaN(updatedMinutes) && !isNaN(updatedSeconds)) {
            setMinutes(updatedMinutes);
            setSeconds(updatedSeconds);


        }
    };



    // const AuctionTeamFn = async () => {
    //     await AuctionTeamById(state).then((res) => {
    //         const remainingBidTime = res?.data.remainingBidTime;
    //         const bidTimeInMinutes = res?.data.bidTime;

    //         if (remainingBidTime === "00:00") {
    //             const totalSeconds = bidTimeInMinutes * 60;
    //             const remainingSeconds = totalSeconds - 1;

    //             const remainingMinutes = Math.floor(remainingSeconds / 60);
    //             const remainingSecondsFormatted = remainingSeconds % 60;
    //             const formattedBidTime = `${String(remainingMinutes).padStart(
    //                 2,
    //                 "0"
    //             )}:${String(remainingSecondsFormatted).padStart(2, "0")}`;

    //             updateTime(formattedBidTime);
    //         } else {
    //             updateTime(remainingBidTime);
    //         }
    //     });
    // };


    const AuctionTeamFn = async () => {
        setLoading(true); // Start loading

        try {
            const res = await AuctionTeamById(state);
            setAuctionTeamImage(res)

            // Check if the response status is 204
            if (res.status === 204) {
                navigate("/player/AuctionPlayer");
                return; // Exit the function early
            }

            const remainingBidTime = res?.data.remainingBidTime;
            const teamStatus = res?.data.status;
            setTotalpoolAmount(res?.data?.totalPoolAmount)
            // Format the remaining bid time first
            const [minutes, seconds] = remainingBidTime.split(":").map(Number);
            const totalSeconds = minutes * 60 + seconds;

            // Check if the team status is "Closed" and remaining bid time is "00:00"
            if (teamStatus === "Closed" && remainingBidTime === "00:00") {
                navigate("/player/AuctionPlayer");
                return; // Exit the function early
            }

            if (remainingBidTime === "00:00") {

                const bidTimeInMinutes = state?.timeLeft; // This can now be a decimal like 0.5
                updateTime(bidTimeInMinutes);
            } else {
                // If remainingBidTime is not "00:00", just update with the existing time
                updateTime(remainingBidTime);
            }
            const result = await AuctionPlaceBid(state?.auctionId)
            setAuctionPlaceData(result?.data)
        } catch (error) {
            console.error("Error fetching auction team data:", error);
            // Handle error appropriately, e.g., show a notification to the user
        } finally {
            setLoading(false); // Stop loading
        }
    };



    // useEffect(() => {
    //     AuctionTeamFn()
    // }, [])
    useEffect(() => {
        // Call the function when the component mounts
        AuctionTeamFn();

        // Add event listener for visibility change
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                AuctionTeamFn(); // Call the function again when the page becomes visible
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);


    useEffect(() => {
        if (currentTotalPlaceBId?.status == "Paused") {

        }

        else {
            if (state.bidTime == 0.5) {
                if (minutes === 0 && seconds === 0) {
                    clearInterval(intervalRef.current);
                } else {
                    intervalRef.current = setInterval(() => {
                        if (seconds === 0) {
                            if (minutes === 0) {
                                clearInterval(intervalRef.current);
                            } else {
                                setMinutes(0);
                                setSeconds(29);
                            }
                        } else {
                            setSeconds((prevSeconds) => prevSeconds - 1);
                        }
                    }, 1000);
                    return () => {
                        clearInterval(intervalRef.current);
                    };
                }
            } else {
                if (minutes === 0 && seconds === 0) {
                    clearInterval(intervalRef.current);
                } else {
                    intervalRef.current = setInterval(() => {
                        if (seconds === 0) {
                            if (minutes === 0) {
                                clearInterval(intervalRef.current);
                            } else {
                                setMinutes((prevMinutes) => prevMinutes - 1);
                                setSeconds(59);
                            }
                        } else {
                            setSeconds((prevSeconds) => prevSeconds - 1);
                        }
                    }, 1000);
                    return () => {
                        clearInterval(intervalRef.current);
                    };
                }
            }
        }



    }, [minutes, seconds, state]);

    const handleClosebutton = () => {
        navigate("/player/AuctionPlayer");
    };


    //      const placeBidTourStarted = useRef(false);
    //     const steps = [
    //         {
    //           element: '#auction_Total_Pool',
    //           intro: 'This section displays Total pool.',
    //           position: 'right'
    //         },
    //          {
    //           element: '#bid_information', // dropdown to filter by manager
    //           intro: 'This Setion is the Player bid information.',
    //           position: 'right'
    //         },
    //         {
    //           element: '#team_image_timmer', // selector for "Live and Upcoming / Closed" tab
    //           intro: 'This section to show the Team Image and Timmer.',
    //           position: 'top'
    //         },
    //         {
    //           element: '.place_bid', // input for searching
    //           intro: 'Click on this Place on bid button then bid is start.',
    //           position: 'right'
    //         },
    //         {
    //           element: '#auction_winning_details', // table listing auctions
    //           intro: 'This section showing the Auction winning details.',
    //           position: 'top'
    //         },
    //         // {
    //         //   element: '.bid-status', // element where "Live 01:43" or "Upcoming" is shown
    //         //   intro: 'Check here to see the current status of each auction.',
    //         //   position: 'bottom'
    //         // },
    //         // {
    //         //   element: '.place-bid-btn', // the blue "Place Bid" button
    //         //   intro: 'Click here to place a bid if the auction is live.',
    //         //   position: 'right'
    //         // }
    //       ];

    //    const startTour = () => {
    //         introJs().setOptions({
    //             steps: steps,
    //             showBullets: false,
    //             nextLabel: 'Next',
    //             prevLabel: 'Previous',
    //             doneLabel: 'Finish',
    //             exitOnOverlayClick: false
    //         }).start();
    //     };
    //     useEffect(() => {
    //         if (!placeBidTourStarted.current) {
    //             startTour();
    //             placeBidTourStarted.current = true;
    //         }
    //     }, []);

    return (
        <>


            <Modal centered show={show}

                backdrop="static"
                keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Bid Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        currentTotalPlaceBId?.bidPlacedBy == userId || getId == userId && getTeamId == state?.teamId && getAuctionId == state?.auctionId ? <h4><span className='text-success'>Congratulations,</span>You won the auction</h4> : <h4>Sorry, You lost the auction</h4>
                    }
                </Modal.Body>
                <Modal.Footer>


                </Modal.Footer>
            </Modal>

            {
                state === null || state === undefined ? <Loader></Loader> :
                    <>
                        <TopNavbar sidebarfun={sidebarfun} />
                        <div className="dasboard-group" >
                            <Sidebar data={data} />
                            <div className={data ? "dashboard-content full-contnet" : "dashboard-content"}>

                                <Row>
                                    <Col md={6}><h1 className="heading-dash">  Place Bid </h1></Col>
                                </Row>
                                <div className='group_data_table p-3'>
                                    {/* <h2 className='currentBid text-center'>Highest Bid {state?.totalPlacedBids == 0 ? 0 : state?.startingBid}</h2> */}
                                    <h2 className='currentBid text-center' id='auction_Total_Pool'>Total Pool : {currentTotalPlaceBId == undefined ? state?.totalPoolAmount : currentTotalPlaceBId?.totalPoolAmount}</h2>

                                    <Row>
                                        <Col md={6} id='bid_information'>

                                            <Form noValidate validated={validated} >
                                                <Form.Group as={Col} md="12 mt-3" className="text-left " controlId="validationCustomCountry">
                                                    <Form.Label>Team</Form.Label>

                                                    <InputGroup hasValidation>

                                                        <Form.Control
                                                            type="text"
                                                            name="teamId"
                                                            disabled
                                                            value={currentTotalPlaceBId == undefined ? state?.item?.teamName : currentTotalPlaceBId?.teamName}
                                                            style={{ height: "46px" }}

                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                        />

                                                        <Form.Control.Feedback type="invalid">
                                                            Please a select Team name.
                                                        </Form.Control.Feedback>
                                                    </InputGroup>
                                                </Form.Group>
                                                <Row>

                                                    <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                                        <Form.Label className="mt-3">  {state?.totalPlacedBids == 0 ? "Start Bid" : "Last Bid"}</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="minBid"
                                                                disabled
                                                                value={currentTotalPlaceBId == undefined ? state?.startingBid : currentTotalPlaceBId?.startingBid}
                                                                style={{ height: "46px" }}
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please Enter a Minimum Bid.
                                                            </Form.Control.Feedback>
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                                        <Form.Label className="mt-3">Bid Time Limit</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="bidTimeLimit"
                                                                style={{ height: "46px" }}
                                                                disabled

                                                                value={state?.bidTime}

                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please Enter a Bid Time Limit.
                                                            </Form.Control.Feedback>
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                                        <Form.Label className="mt-3">Total Placed Bids</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="bidPlacedBy"
                                                                style={{ height: "46px" }}
                                                                disabled
                                                                // value={state?.totalPlacedBids}
                                                                value={currentTotalPlaceBId == undefined ? state?.totalPlacedBids : currentTotalPlaceBId?.totalPlacedBids}

                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please Enter a Placed Bids.
                                                            </Form.Control.Feedback>
                                                        </InputGroup>
                                                    </Form.Group>

                                                    <Form.Group as={Col} md="6 mt-3" controlId="validationCustomFristname">

                                                        <Form.Label className="mt-3">Minimum Bid Increment</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="bidIncrement"
                                                                style={{ height: "46px" }}
                                                                disabled
                                                                // value={state?.bidIncrement}
                                                                value={currentTotalPlaceBId === undefined ? state?.bidIncrement : autionAllData?.bidIncrement}

                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please Enter a Minimum Bid Increment.
                                                            </Form.Control.Feedback>
                                                        </InputGroup>
                                                    </Form.Group>


                                                    <Col md="6">
                                                        <Form.Label className="mt-3">Minimum Next Bid </Form.Label>
                                                        <h2 className='currentBid'>
                                                            {/* {state?.totalPlacedBids === 0 ? state?.startingBid : currentTotalPlaceBId?.startingBid + state?.bidIncrement} */}
                                                            {currentTotalPlaceBId?.currentBidAmount}
                                                            {/* {currentTotalPlaceBId == undefined ? state?.startingBid : currentTotalPlaceBId.startingBid + state?.bidIncrement} */}
                                                        </h2>
                                                    </Col>
                                                    <Col md="6" className='mt-3'>
                                                        <Form.Group controlId="validationCustomFristname">
                                                            <Form.Label >Custom Bid Amount</Form.Label>
                                                            <InputGroup hasValidation>
                                                                <Form.Control
                                                                    type="number"
                                                                    style={{ height: "46px" }}
                                                                    name="bidAmount"
                                                                    // minLength={6}
                                                                    value={oldBidAmount}
                                                                    onChange={handelBidAmount}
                                                                    placeholder="Enter your custom bid amount"
                                                                    aria-describedby="inputGroupPrepend"
                                                                // inputProps={{ maxLength: 6 }}
                                                                />

                                                            </InputGroup>

                                                        </Form.Group>

                                                        {errorMessage == true ? <p className='err-message'>
                                                            Bid Amount should be equal and greater than Minimum Next Bid.
                                                        </p> : ""}
                                                        <p className='mt-2'>    All Bidding Amount is in USD</p>



                                                    </Col>

                                                    <Form.Group as={Col} md="12" className='place_bid'>




                                                        {
                                                            loading ? <Loader></Loader> : isNaN(currentTotalPlaceBId?.startingBid) ? "" :
                                                                minutes === 0 && seconds === 0 ?
                                                                    <Button type='button' disabled onClick={handleSubmit} className='update-btn-prof  ms-0' >Place My Bid</Button>
                                                                    : <Button
                                                                     type='button'
                                                                     disabled={
                                                                        currentTotalPlaceBId?.bidPlacedBy == userId ||
                                                                        currentTotalPlaceBId?.status === "Paused" ||
                                                                        (getId == userId &&
                                                                        getTeamId == state?.teamId &&
                                                                        getAuctionId == state?.auctionId)
                                                                    }
                                                                      onClick={handleSubmit} className='update-btn-prof ms-0'>Place My Bid</Button>

                                                        }
                                                        {currentTotalPlaceBId?.bidPlacedBy == userId || getId == userId && getTeamId == state?.teamId && getAuctionId == state?.auctionId ? <>

                                                            <p class="bidWinner mt-3">You are the highest bidder</p>

                                                        </> : ""}
                                                        <br />


                                                    </Form.Group>
                                                </Row>
                                            </Form>

                                            <div className='border-right'></div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='placeBid-sec' id='team_image_timmer'>
                                                <h2 className='text-white'>
                                                    {state?.auctionName} - {autionAllData?.teamName}
                                                </h2>
                                                {
                                                    autionAllData?.teamImage == null ? <img src='/image/team-icon.png' width={100}></img> : <img src={ImageUrl + autionAllData?.teamImage} width={100}></img>
                                                }

                                                <div className='group-auctionBid-date'>
                                                    {show ? (
                                                        <Col md={12}>
                                                            <p>Bidding Ended</p>
                                                        </Col>
                                                    ) : (
                                                        <Row>
                                                            <Col md={12}>
                                                                {
                                                                    currentTotalPlaceBId?.status === "Paused" ? <p className='text-danger'>Paused</p> :
                                                                        <span style={{ color: minutes === 0 && seconds <= 10 ? 'red' : 'white' }}>


                                                                            {
                                                                                loading || minutes === undefined || seconds === undefined ? <Loader /> : `${minutes?.toString().padStart(2, '0')}:${seconds?.toString().padStart(2, '0')}`
                                                                            }

                                                                        </span>
                                                                }

                                                            </Col>
                                                        </Row>
                                                    )}
                                                </div>
                                                {
                                                    state?.auctionImage == null ? <img src="../image/auctionImage.png" className='img-fluid ImageAuction_bid' width={300} /> : <img src={ImageUrl + state?.auctionImage} className='img-fluid' width={300}></img>
                                                }

                                            </div>

                                        </Col>
                                    </Row>
                                    {/* <div className='border_win'>
                                        <h5>Auction Winnings</h5>
                                        <ul className='winner_list'>
                                            {
                                                winnerpercentages?.length > 0 && winnerpercentages?.map((item, i) => (
                                                    <li key={i} className='d-flex flex-column align-center m-20 box_shadow_custom' >
                                                        <p >
                                                            {winnertitles[i] + " - "}
                                                            <span className='bold_custom'>
                                                                {(winnerpercentages[i]) + "%"}
                                                            </span>
                                                        </p>
                                                        <p className='winner_names'>

                                                            {currentTotalPlaceBId == undefined ? "$" + (((state?.totalPoolAmount) * winnerpercentages[i]) / 100).toFixed(2) : "$" + (((currentTotalPlaceBId?.totalPoolAmount) * winnerpercentages[i]) / 100).toFixed(2)}
                                                        </p>
                                                    </li>
                                                ))
                                            }
                                            <li>                    </li>
                                        </ul>
                                    </div> */}
                                    {/* <ShowPlaceBid currentTotalPlaceBId={currentTotalPlaceBId}/> */}
                                    <div className='border_win' id='auction_winning_details'>
                                        <h5>Auction Winnings</h5>
                                        <ul className='winner_list'>
                                            {
                                                winnerpercentages?.length > 0 && auctionPlaceData?.map((item, i) => (
                                                    <li key={i} className='d-flex flex-column align-center m-20 box_shadow_custom' >
                                                        <p >
                                                            {item?.winnerTitle + " - "}
                                                            <span className='bold_custom'>
                                                                {(item?.winnerPercentage) + "%"}
                                                            </span>
                                                        </p>
                                                        <p className='winner_names'>
                                                            {item?.winningAmount}
                                                            {/* {currentTotalPlaceBId == undefined ? "$" + (((state?.totalPoolAmount) * winnerpercentages[i]) / 100).toFixed(2) : "$" + (((currentTotalPlaceBId?.totalPoolAmount) * winnerpercentages[i]) / 100).toFixed(2)} */}
                                                        </p>
                                                    </li>
                                                ))
                                            }
                                            <li>                    </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </>
            }

        </>
    )
}


//  const result = await AuctionPlaceBid(autionId)